qw-update-search {
  background-color: white;
  cursor: initial;
  h4 {
    font-family: var(--qw-hotel-font-family-b);
    font-size: 30px;
    margin: 0 0 0px;
    @media (max-height: 615px) and (min-width: 738px) {
      font-size: 24px;
    }
  }
  .qw-modal--message {
    border-radius: 10px;
    display: block;
    background-color: #f4f4f4;
    position: absolute;
    top: 22px;
    left: 50%;
    padding: 10px 12px;
    transform: translateX(-50%);
    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.15);
    bottom: auto;
    z-index: 2;
    p {
      color: #0087e8;
      margin: 0;
      font-size: 13px;
      font-family: var(--qw-hotel-font-family-r);
      font-weight: 600;
    }
  }
  .qw-update-search__fields {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 120px 0 73px;
    position: relative;
    @media only screen and (max-width: 738px) {
      margin: 0;
      width: 100%;
    }
    @supports (-webkit-touch-callout: none) {
      /* CSS specific to iOS devices */
      @media only screen and (max-width: 738px) {
        flex: 0 0 100%;
      }
    }
    @media (max-height: 615px) and (min-width: 738px) {
      margin: 38px 0 24px;
    }

    .qw-update-search--input-wrapper {
      margin: 0 10% 0 0;
      width: 45%;
      position: relative;
      @media only screen and (max-width: 738px) {
        display: flex;
        width: 100%;
        margin-right: 0;
        margin-top: 48px;
      }
      &:last-of-type,
      &:nth-child(4) {
        margin-top: 56px;
        @media only screen and (max-width: 738px) {
          margin-top: 48px;
        }
        @media (max-height: 615px) and (min-width: 738px) {
          margin-top: 32px;
        }
      }
      &:nth-child(3),
      &:last-of-type {
        margin-right: 0;
      }

      &:nth-child(5) {
        @media only screen and (max-width: 976px) {
          display: flex;
        }
      }
    }
    qw-input {
      border-right: 0;
      padding: 0;
      background-position: 98% 39%;
      span {
        border-bottom: 1px solid #bfc0c0;
        padding-bottom: 9px;
        display: block;
        width: 100%;
        text-decoration: none;
        background-image: url('#{$base-url}img/icons/select-arrow-modal.svg');
        background-size: 11px;
        background-position: 98% center;
        background-repeat: no-repeat;
        padding-right: 24px;
        font-family: var(--qw-hotel-font-family-b);
        font-size: 21px;
        cursor: pointer;
      }

      .qw-input__label {
        font-family: var(--qw-hotel-font-family-m);
        font-size: 16px;
      }

      &.qw-group--link {
        width: 100%;
        .qw-span--label {
          margin-top: 16px;
          .qw-input__label {
            font-family: var(--qw-hotel-font-family-b);
            font-size: 20px;
          }
          span {
            font-size: 19px;
            margin-left: 12px;
            text-decoration: underline;
            cursor: pointer;
            border: none;
            background: none;
            padding: 0;
            font-family: var(--qw-hotel-font-family-r);
            width: auto;
            color: var(--qw-hotel-neutral-dark);
          }
        }
      }
    }
  }

  .qw-update-search__info {
    max-width: 80%;
    @media only screen and (max-width: 738px) {
      max-width: 100%;
    }
    &--image {
      width: 100%;
      height: auto;
      max-width: 150px;
      margin-bottom: 6px;
      @media (max-height: 615px) and (min-width: 738px) {
        max-width: 120px;
      }
    }
    &--title {
      font-family: var(--qw-hotel-font-family-m);
      font-size: 16px;
      margin: 0 0 0px;
      color: #006edd;
      line-height: 1.4;
      @media only screen and (max-width: 738px) {
        font-size: 14px;
        margin-top: 48px;
      }
      @media (max-height: 615px) and (min-width: 738px) {
        font-size: 15px;
      }
    }
    &--details {
      font-family: var(--qw-hotel-font-family-r);
      font-size: 16px;
      margin: 0 0 0px;
      line-height: 1.4;
      @media only screen and (max-width: 738px) {
        font-size: 14px;
      }
      @media (max-height: 615px) and (min-width: 738px) {
        font-size: 15px;
      }
    }
  }
  .qw-update-search__info + .qw-button {
    margin: 0;
    color: white;
    background-color: #414141;
    border-radius: 100px;
    border: solid 0px var(--qw-hotel-primary-color);
    font-family: var(--qw-hotel-font-family-b);
    white-space: nowrap;
    margin: auto 0 0 auto;
    font-size: 24px;
    padding: 6px 16px;
    @media only screen and (max-width: 738px) {
      position: relative;
      margin: 84px auto 0;
    }
    @supports (-webkit-touch-callout: none) {
      /* CSS specific to iOS devices */
      @media only screen and (max-width: 738px) {
        margin: 84px auto 60px;
        display: inline-block;
      }
    }
    @media (max-height: 615px) and (min-width: 738px) {
      font-size: 21px;
    }
  }

  qw-room-type-list .qw-room-type-list__item {
    @media (max-height: 570px) and (min-width: 738px) {
      margin: 10px 0 !important;
    }
  }

  qw-calendar {
    z-index: 2;
    bottom: auto;
    top: 58px;
    @media (max-height: 900px) and (min-width: 738px) {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  qw-location-list {
    width: 100%;
    padding: 14px 24px;
    border-radius: 0;
    border: 0;
    border-top: solid 2px var(--qw-hotel-primary-color);
    box-shadow: 0px 0px 5px rgb(0 0 0 / 25%);
    z-index: 2;
    bottom: auto;
    margin: -1px 0 0 0;
    .qw-location-list__item {
      font-size: 21px;
      margin: 14px 0;
    }

    .qw-location-list__item:last-of-type {
      margin: 14px 0;
    }
  }

  qw-guest {
    padding: var(--qw-hotel-gap-md);
    width: 100%;
    border: 0;
    border-radius: 0;
    border-top: 2px solid var(--qw-hotel-primary-color);
    box-shadow: 0px 0px 5px rgb(0 0 0 / 25%);
    z-index: 2;
    bottom: auto;
    margin: -1px 0 0 0;
    min-width: 100%;
    .qw-guest__counter-wrapper {
      margin-bottom: var(--qw-hotel-gap-md);
    }
    .qw-guest__counter-wrapper__label {
      font-family: var(--qw-hotel-font-family-b);
    }
    .qw-guest__counter-wrapper__sublabel {
      display: none;
    }
    qw-counter {
      padding: 4px 12px;
    }
  }

  qw-room-type-list {
    border: 0;
    border-radius: 0;
    border-top: 2px solid var(--qw-hotel-primary-color);
    box-shadow: 0px 0px 5px rgb(0 0 0 / 25%);
    width: 100%;
    max-width: 100%;
    padding-top: 14px;
    padding-bottom: 14px;
    z-index: 2;
    display: none;
    position: absolute;
    padding: 14px 30px;
    margin: -1px 0 0 0;
    background-color: white;
    &.qw-component--show {
      display: flex;
      flex-direction: column;
    }

    @media only screen and (max-width: 738px) {
      top: 56px;
      bottom: auto;
    }

    .qw-room-type-list__item {
      margin: 14px 0;
      font-size: 20px;
      font-family: var(--qw-hotel-font-family-b);
      cursor: pointer;
    }
    .qw-room-type-list__item:last-of-type {
      margin: 14px 0;
    }
  }
}
